import { render, staticRenderFns } from "./WaitlistOTPVerify.vue?vue&type=template&id=bdc671a2"
import script from "./WaitlistOTPVerify.vue?vue&type=script&lang=js"
export * from "./WaitlistOTPVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports